// AppearanceConfiguration.js - Main entry point for Appearance Configuration
// This component renders the item lines (appearance templates) configuration
import React from 'react';
import { Box } from '@mui/material';
import ItemLinesTab from './ItemLinesTab';

const AppearanceConfiguration = () => {
  return (
    <Box sx={{ width: '100%' }}>
      <ItemLinesTab />
    </Box>
  );
};

export default AppearanceConfiguration;
